// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0bxq\\+lVI\\+WfiVC {\n  background: var(--ds-background-accent-gray-subtlest, #EBECF0);\n}\n.ZZ\\+B1\\+ksnEcE8d {\n  margin-right: 8px;\n}\n.ZZ\\+B1\\+ksnEcE8d:visited,\n.ZZ\\+B1\\+ksnEcE8d:active {\n  outline: none;\n}\n.ZZ\\+B1\\+ksnEcE8d:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.ZZ\\+B1\\+ksnEcE8d .icon-template-card {\n  margin-right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": "_0bxq+lVI+WfiVC",
	"cardTemplateButton": "ZZ+B1+ksnEcE8d"
};
export default ___CSS_LOADER_EXPORT___;
